'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/axios/lib/cancel/isCancel.js
// module id = 47
// module chunks = 0 1 2 3 4 5 6